"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestShiftsEmployee = void 0;
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const query_1 = __importDefault(require("./query"));
const EMPLOYEE_SHIFTS_QUERY = (0, graphql_tag_1.default) `query ShiftsEmployeeQuery (
  $id: ID!,
  $workspace: ID,
  $period: PeriodFreeInput,
) {
  user(
    id: $id
  ) {
    shifts (
      period: $period
      workspace: $workspace
    ) {
      transfer {
        ${query_1.default.OFFER_PARAMS_TRANSFER}
      }
      ${query_1.default.SHIFT_PARAMS_BASIC}
      ${query_1.default.SHIFT_PARAMS_ATTENDANCE}
    }
  }
}`;
const requestShiftsEmployee = async (variables) => {
    const { data, errors } = await (0, apollo_1.query)(EMPLOYEE_SHIFTS_QUERY, {
        variables,
    });
    (0, error_handler_1.processErrors)(errors);
    return data?.user.shifts;
};
exports.requestShiftsEmployee = requestShiftsEmployee;
// async function requestShiftsEmployee(variables, token) {
//   const response = await fetchRequest({
//     query: EMPLOYEE_SHIFTS_QUERY,
//     variables,
//     token,
//   })
//   if (!response) return errUtil.noResponse()
//   const { errors, data } = response
//   if (errors) {
//     return errUtil.apiError('shifts-employee', errors)
//   }
//   return data.user.shifts
// }
exports.default = exports.requestShiftsEmployee;
